/** Shared base for compact pill badges (see `.fs-pill` in index.css). */
export const PILL_BADGE_BASE = "fs-pill shrink-0 rounded-full border leading-none";
